export default {
  title: 'Жилой комплекс "{complexTitle}"',
  address: 'Татарстан Республика, г Казань, {address}, корпус {section}',
  linkToDocs: 'Документация объекта на дом.рф',
  photoCount: '{count} фото'
}
